import { formatPriceChanges } from 'utils/pricechange-util'
import { useTranslation } from 'react-i18next'

export const usePriceComparisonChanges = (priceData) => {
    const { t } = useTranslation()
    const {
        increasesResponse = {},
        decreaseResponse = {},
        increaseTotal = 0,
        decreaseTotal = 0,
        total = 0,
        documentFee = {}
    } = priceData

    const priceIncrease = formatPriceChanges(increasesResponse, documentFee?.name)

    const priceDecrease = formatPriceChanges(decreaseResponse, documentFee?.name)

    const totalChanges =
        parseInt(Object.keys(increasesResponse)?.length) + parseInt(Object.keys(decreaseResponse)?.length)

    const formattedIncreaseTotal = increaseTotal.toFixed(2)
    const formattedDecreaseTotal = decreaseTotal.toFixed(2)
    const formattedTotalPrice = total.toFixed(2)

    const increasesPopOverData = {
        title: t('increases'),
        desc: t('increases_popover_description')
    }

    const decreasesPopOverData = {
        title: t('decreases'),
        desc: t('decreases_popover_description')
    }

    const totalPopOverData = {
        title: t('total_net_change'),
        desc: t('total_change_popover_description')
    }

    const transformOrigin = {
        vertical: 'top',
        horizontal: 'center'
    }

    return {
        priceIncrease,
        priceDecrease,
        totalChanges,
        formattedIncreaseTotal,
        formattedDecreaseTotal,
        formattedTotalPrice,
        increasesPopOverData,
        decreasesPopOverData,
        totalPopOverData,
        transformOrigin
    }
}
